<script setup lang="ts">
import type { TooltipRootEmits, TooltipRootProps } from 'reka-ui'
import { TooltipRoot, useForwardPropsEmits } from 'reka-ui'

const props = defineProps<TooltipRootProps>()
const emits = defineEmits<TooltipRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
const open = ref(false)
</script>

<template>
  <TooltipRoot
    v-bind="forwarded"
    :open="open"
    :delay-duration="0"
    @update:open="open = $event"
  >
    <span @click="open = true">
      <slot />
    </span>
  </TooltipRoot>
</template>
